import { ReactElement, ReactNode } from 'react';
import useSWR from 'swr';
import { LinkerContext } from './types';
import { Alert, LoadingContainer } from '@ff-it/ui';
import { useFiancePeriod } from './useFinancePeriod';

type LinksProviderProps = {
  url: string;
  children: (ctx: LinkerContext) => ReactNode;
  shouldHaveFiancePeriod: boolean;
};

export function LinksProvider({ url, children, shouldHaveFiancePeriod }: LinksProviderProps): ReactElement {
  const financePeriod = useFiancePeriod();
  const financePeriodRequired = shouldHaveFiancePeriod && !financePeriod;
  const { data, error, isLoading } = useSWR<LinkerContext>(
    financePeriodRequired
      ? null
      : {
          url,
          method: 'GET',
          queryParams: {
            links: financePeriod ? `${financePeriod.start},${financePeriod.end}` : '',
          },
        },
    null,
    {
      keepPreviousData: false,
    },
  );

  if (error) {
    throw error;
  }

  return (
    <LoadingContainer loading={isLoading} className="flex-grow-1 flex-column d-flex">
      {financePeriodRequired ? (
        <Alert heading="Finance period required">Set finance period to invoice or recalcualte</Alert>
      ) : data ? (
        children(data)
      ) : null}
    </LoadingContainer>
  );
}
